import { defineMessages, useIntl } from 'react-intl';

import { useContentfulContentTypeEntry } from '@order/Contentful';

/**
 * Returns the trademark copy, sourced from Contentful with a local fallback.
 * @see {@link https://app.contentful.com/spaces/wme4s8lvzccr/entries/lUNJYtwwtNw2B9S549Bug?focusedField=trademark}
 */
export const useTrademark = () => {
  const { formatMessage } = useIntl();

  const { data } = useContentfulContentTypeEntry<ContentfulOrganizationLinksFooter>({
    contentType: CONTENT_TYPE,
  });

  return data?.fields?.trademark ?? formatMessage(messages.trademark);
};

// ─── Constants ───────────────────────────────────────────────────────────────

const CONTENT_TYPE = 'organizationLinksFooter';

// ─── Types ───────────────────────────────────────────────────────────────────

type ContentfulOrganizationLinksFooter = Readonly<{
  trademark?: string;
}>;

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  trademark: {
    defaultMessage: 'Sweetgreen® and the Hex Bowl™ are trademarks of Sweetgreen, Inc.',
    description: 'Trademark | Fallback',
  },
});
